import CryptoJS from "crypto-js";
import { key } from "../config";

export const Encryption = (text) => {
  const encrypted = CryptoJS.AES.encrypt(text, key).toString();
  const base64Encoded = btoa(encrypted);
  return base64Encoded;
};

// Decryption function
export const Decryption = (base64Encoded) => {
  const decrypted = CryptoJS.AES.decrypt(atob(base64Encoded), key).toString(CryptoJS.enc.Utf8);
  return decrypted;
};
